import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {ReactComponent as ChevronRight} from '../../assets/icons/arrow_right_slim.svg';
import {ReactComponent as ChevronLeft} from '../../assets/icons/arrow_left_slim.svg';
// import {zoomIn} from '../../store/actionsCreator/zoomActionCreators';
// import {changeCarouselActiveSlide} from '../../store/actionsCreator/carouselActionsCreator';
import {IAppState} from '../../store/models';
// import {useMediaQuery} from '@material-ui/core';
import {Box, Button} from "@mui/material";
import {makeStyles} from "@mui/styles";
import tinycolor from "tinycolor2";
import {useParams} from "react-router-dom";
import {ParamTypesDto} from "../../dtos/flyer";
import {
    calculateCorrectPageFromShareLink,
    getConvertedPageNumberToSlideNumber,
} from "../../com/globalsFunctions/globalFunctions";
import {isMobile} from "react-device-detect";

const useStyles = makeStyles(() => ({
    arrowButtonWrapper: (props: any) => ({
        border: `0`,
        position: `absolute`,
        zIndex: 2,
        height: "100%",
        width: "56px",
        top: "0",
        left: "0",
        display: "flex",
        alignItems: "center",
        backgroundColor: `transparent`,
        "&:hover": {
            backgroundColor: `#CCDAE680`,
        },
        '& > .MuiButton-root': {
            backgroundColor: props.primaryColor ? props.primaryColor : '#C32E43',
            cursor: `pointer`,
            height: `112px`,
            width: "56px",
            borderRadius: "0",
            padding: "28px 16px",
            '& > svg': {
                width: `100%`,
                height: `100%`,
                "& > path": {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`
                },
                transition: "transform 0.3s"
            },
            '&.Mui-disabled': {
                opacity: `.3`
            },
            '&:hover': {
                backgroundColor: props.primaryColor ? `${props.primaryColor}B3!important` : '#C32E43B3!important',
            },
        },
        '&.arrowRight': {
            right: '0',
            left: `auto`,
            '&.arrowRightBasketOpened': {
                right: !props.isVerticalScrolling ? `430px` : `auto`,
            },
            "& > .MuiButton-root": {
                "&:active:not(:disabled)": {
                    "& > svg": {
                        transform: "translate(3px,0)"
                    }
                },
            }
        },
        '&.arrowLeft': {
            left: '0',
            right: `auto`,
            '&.arrowLeftBasketOpened': {
                left: !props.isVerticalScrolling ? `430px` : `auto`,
            },
            "& > .MuiButton-root": {
                "&:active:not(:disabled)": {
                    "& > svg": {
                        transform: "translate(-3px,0)"
                    }
                },
            }
        },
    }),
}))

// type ArrowProps = {
//     arrow: 'left' | 'right',
//     // onClick?: () => void;
//     isHebrewStyle?: boolean,
// }

const Arrow = (props: any) => {
    const {arrow, isHebrewStyle, sliderRef} = props;
    // const dispatch = useDispatch();
    const {pageNumber} = useParams<ParamTypesDto>();
    const {controlsBranch, flyersBranch, selectedSpot} = useSelector((state: IAppState) => state);
    const {showBasket, isHelpScreen, showSearch, isTocOpen, shareMenu} = controlsBranch;
    const {data} = flyersBranch;
    const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;
    //get lowest number in URL pages range
    const pageStringToNumberIndex = useMemo(() => calculateCorrectPageFromShareLink(pageNumber), [pageNumber]);
    //convert page number to slide number
    const currentSlideNumber = useMemo(() => getConvertedPageNumberToSlideNumber(pageStringToNumberIndex, isOnePageOrientation, isHebrewStyle, data?.pages)
        , [pageStringToNumberIndex, isMobile, isHebrewStyle, data?.pages.length, isOnePageOrientation]);

    const flyerBasic = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const isLightGuiColor = tinycolor(flyerBasic?.primaryColorRgb).isLight();
    const fontsGuiColor = flyerBasic?.fontsColorRgb || "#000000";
    // const isVerticalScrolling = true;
    // const isOnePageOrientation: boolean = false;
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    // const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3;

    const stylesProperties = {
        primaryColor: data?.primaryColorRgb ? data?.primaryColorRgb : `#C32E43`,
        isVerticalScrolling: isVerticalScrolling,
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    };
    const classes = useStyles(stylesProperties);
    const [disableBtn, setDisableBtn] = useState(false);

    useEffect(() => {
        let disabled = false;

        if (!data) {
            setDisableBtn(disabled);
            return;
        }

        const isLastPage = currentSlideNumber === data.pages.length - 1;
        const isFirstPage = currentSlideNumber === 0;
        const isOddPageCount = data.pages.length % 2 === 1;

        if (!isOnePageOrientation) {
            if ((arrow === 'left' && isFirstPage) ||
                (arrow === 'right' && (currentSlideNumber * 2 === data.pages.length || (isOddPageCount && data.pages.length - currentSlideNumber * 2 === 1)))) {
                disabled = true;
            }
        } else {
            if ((arrow === 'left' && isFirstPage) ||
                (arrow === 'right' && isLastPage)) {
                disabled = true;
            }
        }

        // if (isHebrewStyle) {
        //     disabled = !disabled;
        // }

        setDisableBtn(disabled);
    }, [currentSlideNumber, isHebrewStyle, data, isOnePageOrientation, arrow]);
    const classNames = () => {
        let classes = '';

        if (arrow === 'left') {
            classes += ' arrowLeft';
        } else if (arrow === 'right') {
            classes += ' arrowRight';
        }

        if (showBasket || isHelpScreen || shareMenu.isOpen || showSearch || isTocOpen || (Boolean(selectedSpot.spot) && !selectedSpot.isExpanded)) {
            if (isHebrewStyle) {
                classes += ' arrowLeftBasketOpened'
            } else {
                classes += ' arrowRightBasketOpened'
            }
        }

        return classes;
    }

    // if(!isTablet){
    const onBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (!e.currentTarget.disabled && sliderRef && sliderRef.current) {
            if (!isHebrewStyle) {
                if (arrow === 'left') {
                    if (currentSlideNumber > 0) {
                        (sliderRef.current as any).slickGoTo(currentSlideNumber - 1);
                        // dispatch(changeCarouselActiveSlide(currentSlideNumber - 1));
                    }
                } else {
                    const decreaseValue = isOnePageOrientation ? 1 : 2;
                    if (data!.pages.length - decreaseValue >= currentSlideNumber) {
                        (sliderRef.current as any).slickGoTo(currentSlideNumber + 1);
                        // dispatch(changeCarouselActiveSlide(currentSlideNumber + 1));
                    }
                }
            } else {
                if (arrow === 'right') {
                    const decreaseValue = isOnePageOrientation ? 1 : 2;
                    if (data!.pages.length - decreaseValue >= currentSlideNumber) {
                        (sliderRef.current as any).slickGoTo(currentSlideNumber + 1);
                        // dispatch(changeCarouselActiveSlide(currentSlideNumber + 1));
                    }
                } else {
                    if (currentSlideNumber > 0) {
                        (sliderRef.current as any).slickGoTo(currentSlideNumber - 1);
                        // dispatch(changeCarouselActiveSlide(currentSlideNumber - 1));
                    }
                }
            }
        }
    }

    return (
        <Box className={`${classes.arrowButtonWrapper} ${classNames()}`}>
            <Button
                aria-label={`action_slider_btn_${arrow}`}
                id={`action_slider_btn_${arrow}`}
                disabled={disableBtn}
                className={`action_slider_btn`}
                onClick={onBtnClick}
            >
                {arrow === 'left' ? (
                    <ChevronLeft/>
                ) : <ChevronRight/>}
            </Button>
        </Box>
    )
}

export default Arrow;